<template>

  <table
      class="table b-table b-table-stacked-xs table-bordered table-sm bg-white text-uppercase"
  >
    <tbody>
    <tr>
      <th colspan="4">
        <h5 class="text-center"><b>Acolhimentos</b></h5>
      </th>
    </tr>
    <tr>
      <td colspan="4">
        <load mode="table"
              v-if="loadingAcolhimentos"/>
        <div class="col-md-12"
             v-else>

          <b-table
              :fields="[
                {
                  key: 'protocolo',
                  label: $t('Detalhes'),
                },
                {
                  key: 'created_at',
                  label: $t('Data'),
                },
          ]"
              :items="AcolhimentosList"
              :responsive="true"
              striped
              hover
              show-empty
              small
              outlined
              stacked="xs"
              table-class="mb-3"
          >
            <template v-slot:cell(protocolo)="data">
              Usuário: <b>{{ data.item.nome_acolhido }}</b><br/>
              Unidade: <b>{{ data.item.unidade_acolhimento.unidade_nome }}</b><br/>
              Protocolo: <b>{{ data.item.protocolo }}</b>
            </template>
            <template v-slot:cell(created_at)="data">
              <b>{{ data.item.data_acolhimento_pia }}</b><br/>
              Hora: <b>{{ data.item.hora_acolhimento_pia }}</b><br/>
            </template>


            <template v-slot:empty="scope">
              <div class="text-center my-5">
                <img
                    :alt="$t('No results')"
                    class="mb-5"
                    src="/img/icons/robot.svg"
                    style="max-height: 165px"
                />
                <h3 class="bold">
                  {{ $t("No records found") }}
                </h3>
              </div>
            </template>
          </b-table>
        </div>
      </td>
    </tr>
    </tbody>
  </table>
</template>

<script>
export default {
  name: "Acolhimentos",
  props: ['familia'],
  data() {
    return {
      AcolhimentosList: [],
      loadingAcolhimentos: true,
    }
  },
  mounted() {
    this.getAcolhimentos();
  },
  methods: {
    getAcolhimentos() {

      this.loadingAcolhimentos = true;
      axios
          .get(`api/dashboard/print/usuarios/acolhimento/criancas/${this.familia}`)
          .then((response) => {
            this.AcolhimentosList = response.data.data;
            this.loadingAcolhimentos = false;
          })
          .catch(() => {
            this.loadingAcolhimentos = false;
          });
    },

  },
}
</script>

<style scoped>

</style>